import { useCallback, useMemo, useState } from 'react';
import useSearchParamsConfig from './useSearchParamsConfig';

export default function usePlaceholderFilters(defaultSearchParams) {
  const filters = useMemo(
    () => ({
      placeholderDisciplines: [],
      placeholderLocations: [],
      placeholderPractices: [],
      placeholderSkills: [],
      placeholderStatusId: 'active',
    }),
    [],
  );

  const [defaultParams] = useState(defaultSearchParams);

  const searchParamsConfig = useSearchParamsConfig();

  const placeholderSearchParamsConfig = useMemo(
    () => ({
      placeholderDisciplines: searchParamsConfig.placeholderDisciplines,
      placeholderLocations: searchParamsConfig.placeholderLocations,
      placeholderPractices: searchParamsConfig.placeholderPractices,
      placeholderSkills: searchParamsConfig.placeholderSkills,
      placeholderStatusId: searchParamsConfig.placeholderStatusId,
      ...defaultParams,
    }),
    [searchParamsConfig, defaultParams],
  );

  const mapUrlSearchParams = useCallback(
    (filters) => ({
      placeholderDisciplineId: filters.placeholderDisciplines?.map((v) => v.id),
      placeholderLocationId: filters.placeholderLocations?.map((v) => v.id),
      placeholderPracticeId: filters.placeholderPractices?.map((v) => v.id),
      placeholderSkillId: filters.placeholderSkills?.map((v) => v.id),
      placeholderStatusId: filters.placeholderStatusId ?? undefined,
    }),
    [],
  );

  const mapClickThroughParams = useCallback(
    (filters) => ({
      placeholderDisciplineId: filters.placeholderDisciplines?.map((v) => v.id),
      placeholderLocationId: filters.placeholderLocations?.map((v) => v.id),
      placeholderPracticeId: filters.placeholderPractices?.map((v) => v.id),
      placeholderSkillId: filters.placeholderSkills?.map((v) => v.id),
      placeholderStatusId: filters.placeholderStatusId ?? undefined,
    }),
    [],
  );

  return useMemo(
    () => ({ filters, searchParamsConfig: placeholderSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams }),
    [filters, placeholderSearchParamsConfig, mapUrlSearchParams, mapClickThroughParams],
  );
}
